<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!-- <TabMenu :menuIndex="menuIndex" :menu="menu" /> -->

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "VehicleGroupList",
  data() {
    return {
      baseUrl: 'cararray',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/group`},
        { name: "车队分组", path: `/vehicle/group`},
        { name: "车辆列表" },
      ],
      menuIndex: '',
      menu: [],
    };
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    getTabData() {
      this.loading = true
      this.tabData = [];
      let url = `${this.baseUrl}/carlist`;
      const params = {
        // userid: this.user.id,
      }
      // console.log(url, params)
      this.post(url, params, ({ car, cararray }) => {
        this.loading = false
        this.setState({
          key: 'car',
          value: car,
        })
        this.setMenu(cararray)
        this.menuIndex = `${this.$route.path}`
        console.log(this.menu)
        console.log(this.menuIndex)
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setMenu(cararray) {
      this.menu = cararray.map((c, i) => {
        console.log(c, i)
        return {
          name: c.arrname,
          // path: `/vehicle/groupList/table/${i + 1}`,
          path: `/vehicle/groupList/table/${c.id}`,
        }
      })
    },
  },
  mounted() {
    this.getTabData()
  },
};
</script>
